module.exports = __webpack_public_path__ + "img/cameroon.50ae7eb1.svg";